import { render } from "./index.vue?vue&type=template&id=2c4b985c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2c4b985c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2c4b985c"

export default script